export default "__VITE_ASSET__quhTVTSl__"